import { render, staticRenderFns } from "./VersionPickerContainer.vue?vue&type=template&id=6be9722c&scoped=true&"
import script from "./VersionPickerContainer.vue?vue&type=script&lang=js&"
export * from "./VersionPickerContainer.vue?vue&type=script&lang=js&"
import style0 from "./VersionPickerContainer.vue?vue&type=style&index=0&id=6be9722c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be9722c",
  null
  
)

export default component.exports